import type { TranslationTag } from '@ps/web-core-intl';
import { Translation } from '@ps/web-shared-components';
import React from 'react';
import type { FC } from 'react';

import CurrencyAmount from '@swf/components/CurrencyAmount/CurrencyAmount';
import { CashierLimitTimespan, CashierLimitTypes, type DepositLimit } from '@swf/first';

import {
  TXTWCL_24hr_deposit_limitX_N0_left_of_ELL,
  TXTWCL_7_day_deposit_limitX_N0_left_o_ELL,
  TXTWCL_Deposit_limit_reached,
  TXTWCL_Regulatory_LimitX_N0_left_of_N_ELL
} from './CollapseButtonLabel.messages.json';

interface CollapseButtonLabelProps {
  overallClosestLimit?: DepositLimit;
}

const CollapseButtonLabel: FC<CollapseButtonLabelProps> = ({ overallClosestLimit }) => {
  if (!overallClosestLimit) {
    return null;
  }

  const { limitType: type, progress, totalAmount, remainingAmount, timespan } = overallClosestLimit;

  if (progress === 100) {
    return <Translation tagName="p" {...TXTWCL_Deposit_limit_reached} />;
  }

  let translationTag: TranslationTag;

  switch (timespan) {
    case CashierLimitTimespan.Daily:
      translationTag = TXTWCL_24hr_deposit_limitX_N0_left_of_ELL;
      break;
    case CashierLimitTimespan.Weekly:
      type === CashierLimitTypes.RegulatoryLimit
        ? (translationTag = TXTWCL_Regulatory_LimitX_N0_left_of_N_ELL)
        : (translationTag = TXTWCL_7_day_deposit_limitX_N0_left_o_ELL);
      break;
    case CashierLimitTimespan.Monthly:
      translationTag = TXTWCL_7_day_deposit_limitX_N0_left_o_ELL;
      break;
    default:
      return null;
  }

  if (!translationTag) {
    return null;
  }

  if (
    (timespan === CashierLimitTimespan.Weekly && type !== CashierLimitTypes.RegulatoryLimit) ||
    timespan === CashierLimitTimespan.Monthly
  ) {
    return (
      <Translation
        tagName="span"
        {...translationTag}
        values={{
          0: timespan === CashierLimitTimespan.Weekly ? 7 : 30,
          1: <CurrencyAmount value={remainingAmount ?? 0} />,
          2: <CurrencyAmount value={totalAmount ?? 0} />
        }}
      />
    );
  }

  return (
    <Translation
      tagName="span"
      {...translationTag}
      values={{
        0: <CurrencyAmount value={remainingAmount ?? 0} />,
        1: <CurrencyAmount value={totalAmount ?? 0} />
      }}
    />
  );
};

export default CollapseButtonLabel;
